type Listener = () => void;

const listeners: Listener[] = [];

export const onHideCover = (listener: Listener): void => {
  listeners.push(listener);
};

export const hideCover = (): void => {
  document.documentElement.classList.add("is-ready");

  gsap.to(".c-cover", {
    opacity: 0,
    display: "none",
    duration: 0.4,
    onComplete() {
      listeners.forEach((listener) => listener());
    }
  });
};
